/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DatasetAudioRecording } from './DatasetAudioRecording';
import {
  DatasetAudioRecordingFromJSON,
  DatasetAudioRecordingFromJSONTyped,
  DatasetAudioRecordingToJSON,
} from './DatasetAudioRecording';

/**
 *
 * @export
 * @interface PaginatedDatasetAudioRecordingList
 */
export interface PaginatedDatasetAudioRecordingList {
  /**
   *
   * @type {number}
   * @memberof PaginatedDatasetAudioRecordingList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedDatasetAudioRecordingList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedDatasetAudioRecordingList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<DatasetAudioRecording>}
   * @memberof PaginatedDatasetAudioRecordingList
   */
  results: Array<DatasetAudioRecording>;
}

/**
 * Check if a given object implements the PaginatedDatasetAudioRecordingList interface.
 */
export function instanceOfPaginatedDatasetAudioRecordingList(
  value: object,
): value is PaginatedDatasetAudioRecordingList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedDatasetAudioRecordingListFromJSON(json: any): PaginatedDatasetAudioRecordingList {
  return PaginatedDatasetAudioRecordingListFromJSONTyped(json, false);
}

export function PaginatedDatasetAudioRecordingListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedDatasetAudioRecordingList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(DatasetAudioRecordingFromJSON),
  };
}

export function PaginatedDatasetAudioRecordingListToJSON(value?: PaginatedDatasetAudioRecordingList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(DatasetAudioRecordingToJSON),
  };
}
